/** Kerry §8 — five retained governance chain stages (display labels). */
export const GOVERNANCE_CHAIN_STAGE_KEYS = [
  'intent_captured',
  'diagnostic',
  'recommendation',
  'governance_check',
  'execution_asset',
] as const;

export type GovernanceChainStepKey = string;

export const GOVERNANCE_CHAIN_STEP_I18N_KEY = (step: string) =>
  `governanceChain.steps.${step}` as const;

export const GOVERNANCE_CHAIN_STEP_COLORS: Record<string, string> = {
  intent_captured: 'bg-[#e8f4ff] text-[#1b5fad]',
  intent_clarified: 'bg-[#e8f4ff] text-[#1b5fad]',
  intent_context: 'bg-[#e8f4ff] text-[#1b5fad]',
  framework_routed: 'bg-[#f0f0ff] text-[#5b47cc]',
  diagnostic: 'bg-[#f0f0ff] text-[#5b47cc]',
  recommendation: 'bg-[#edfbf4] text-[#00874c]',
  governance_check: 'bg-[#fff8e6] text-[#b38600]',
  execution_asset: 'bg-[#f4f9ff] text-[#3d5585]',
  escalation: 'bg-[#fff1f0] text-[#d93025]',
};
